module.exports = __webpack_public_path__ + "media/recipes/12-89e200fd.png";